import * as methods from './methods';

export function normalizeRules(rules) {
  const normalized = rules === 'string'
    ? { [rules]: true }
    : Object.assign({}, rules);

  for (const key in normalized) {
    if (!normalized.hasOwnProperty(key)) {continue;}
    normalized[key] = normalizeRule({ [key]: normalized[key] });
  }

  return normalized;
}

export function normalizeRule(rule) {
  const keys = Object.keys(rule);

  if (keys.length > 1) {
    throw new Error('Single rule cannot contain more than one key');
  }

  let ruleData = rule[keys[0]];

  if (typeof ruleData === 'string') {
    ruleData = { message: ruleData };
  } else if (typeof ruleData !== 'object') {
    ruleData = { data: ruleData };
  }

  ruleData = Object.assign({}, { message: 'Incorrect value' }, ruleData);

  return ruleData;
}

export function createValidator(rules, additionalMethods) {
  const localMethods = Object.assign({}, methods, additionalMethods);

  return (values) => {
    let errors = {};

    for (const key of Object.keys(values)) {
      if (!rules[key]) {continue;}
      const fieldRules = normalizeRules(rules[key]);

      for (const rule of Object.keys(fieldRules)) {
        if (!fieldRules[rule]) {
          continue;
        }

        if (!localMethods[rule]) {
          throw new Error(`Validation method ${rule} does not exist`);
        }

        const value = values[key] === 0 ? 0 : values[key] || '';
        const result = localMethods[rule](value, fieldRules[rule], values);

        if (!result) {
          errors[key] = fieldRules[rule].message;
        }
      }
    }

    return errors;
  };
}



// WEBPACK FOOTER //
// ./src/utils/validate/index.js